export enum SubscriptionPlan {
  Free = 'Free',
  Starter = 'Starter',
  Professional = 'Professional',
  Enterprise = 'Enterprise'
}

export enum BillingCycle {
  Monthly = 'Monthly',
  Annual = 'Annual'
}

export interface SubscriptionLimits {
  maxWorkers: number;
  maxActiveJobs: number;
  maxPhotosPerLog: number;

  hasLiveMap: boolean;
  hasFullGps: boolean;
  hasExcelExport: boolean;
  hasPdfWatermark: boolean;
  hasBrandedPdf: boolean;
  hasReports: boolean;
  hasWorkerProfiles: boolean;
  hasNotifications: boolean;

  // NEW
  hasAiInsights: boolean;
  aiInsightLimit?: number;
  hasComplianceExport: boolean;

  supportLevel: string;
}

export interface CurrentSubscription {
  id: string;

  plan: SubscriptionPlan;
  billingCycle: BillingCycle;
  status: string;

  currentPeriodStart: string;
  currentPeriodEnd: string;
  daysRemaining: number;

  isActive: boolean;

  // Trial
  isTrial: boolean;
  isTrialValid: boolean;
  trialDaysRemaining: number;
  trialEndDate?: string;

  // AI Insights
  hasAiInsights: boolean;
  aiInsightLimit?: number;
  aiInsightConsumed: number;
  aiInsightsRemaining?: number;
  canUseAiInsights: boolean;

  // Versioning
  planVersion: number;

  limits: SubscriptionLimits;
}

export interface PlanDefinition {
  plan: string;
  planValue: number;

  limits: SubscriptionLimits;

  priceMonthly: number;
  priceAnnual: number;
  annualSaving: number;

  // NEW
  hasAiInsights: boolean;
  aiInsightLimit?: number;
  aiLabel: string;
}

export interface PaymentInit {
  paymentUrl: string;
  reference: string;
  amountUsd: number;
  amountNgn: number;
  exchangeRate: number;
  plan: string;
  billingCycle: string;
}